import { InjectionToken } from '@angular/core';
import { SidebarItem } from '../store/models/sidebar-item.model';

/**
 * Injection token that can be used to provide the array of sidebar items for an application.
 */
export const SIDEBAR_ITEMS = new InjectionToken<SidebarItem[]>('SIDEBAR_ITEMS');
